import CreateProjectTab from 'components/project/clinic/CreateProjectTab';
import ProjectOptionAdvanced from 'components/project/clinic/ProjectOptionAdvanced';
import ProjectOptionBasic from 'components/project/clinic/ProjectOptionBasic';
import { useCreateProjectOption } from 'lib/hooks/project/useCreateProjectOption';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

function CreateProjectOptionContainer() {
  // SECTION: declare hooks
  const {
    isSelectedTooth,
    optionTab,
    optionAdvancedInfoList,
    advancedOption,
    isPhotogrammetry,
    implantType,
    implantList,
    implantAbutmentMaterialIdx,
    abutmentList,
    implantScanbodyScanIdx,
    scanbodyList,
    optionDefaultInfoList,
    defaultOption,
    implantLibrary,
    isSituScanDisabled,
    pimType,
    onTabChange,
    onCheckChange,
    onOptionChange,
    onImplantChange,
    onAbutmentMaterialChange,
    onScanbodyScanChange,
    onLibraryClick,
    onDeleteItemClick,
  } = useCreateProjectOption();
  const { t } = useTranslation();

  return (
    <StyledCreateProjectOption $isSelectedTooth={isSelectedTooth}>
      <div className="createProjectOptionContainer__tab_container">
        <CreateProjectTab
          tabTitle={t('GLOBAL_OPTION')}
          tabIndex={optionTab}
          tabList={[
            { index: 0, label: t(`PROJECT_OPTION_TAB_BASIC`) },
            { index: 1, label: t(`PROJECT_OPTION_TAB_ADVANCED`) },
          ]}
          onTabChange={onTabChange}
        />
      </div>
      <div className="createProjectOptionContainer__content">
        {isSelectedTooth && optionTab === 0 && (
          <ProjectOptionBasic
            implantType={implantType}
            implantList={implantList}
            implantAbutmentMaterialIdx={implantAbutmentMaterialIdx}
            abutmentList={abutmentList}
            implantScanbodyScanIdx={implantScanbodyScanIdx}
            scanbodyList={scanbodyList}
            optionDefaultInfoList={optionDefaultInfoList}
            defaultOption={defaultOption}
            isPhotogrammetry={isPhotogrammetry}
            implantLibrary={implantLibrary}
            isSituScanDisabled={isSituScanDisabled}
            pimType={pimType}
            onCheckChange={onCheckChange}
            onOptionChange={onOptionChange}
            onImplantChange={onImplantChange}
            onAbutmentMaterialChange={onAbutmentMaterialChange}
            onScanbodyScanChange={onScanbodyScanChange}
            onLibraryClick={onLibraryClick}
            onDeleteItemClick={onDeleteItemClick}
          />
        )}
        {isSelectedTooth && optionTab === 1 && (
          <ProjectOptionAdvanced
            optionAdvancedInfoList={optionAdvancedInfoList}
            advancedOption={advancedOption}
            isPhotogrammetry={isPhotogrammetry}
            onCheckChange={onCheckChange}
            onOptionChange={onOptionChange}
          />
        )}
      </div>
    </StyledCreateProjectOption>
  );
}

const StyledCreateProjectOption = styled.div<{ $isSelectedTooth: boolean }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ $isSelectedTooth }) => ($isSelectedTooth ? 'transparent' : '#f9f9fb')};
  .createProjectOptionContainer__tab_container {
  }
  .createProjectOptionContainer__content {
    height: 100%;
    overflow: auto;
  }
`;

export default CreateProjectOptionContainer;
